import { ITjipInputSelection } from './ITjipInputSelection';

export class TjipSelectionService {
  public static getInputSelection(): ITjipInputSelection {
    const result: ITjipInputSelection = {
      text: null,
      start: 0,
      end: 0
    };
    const elm: HTMLInputElement = window.document.activeElement as HTMLInputElement;
    if (this.isInputControl(elm)) {
      result.start = elm.selectionStart as number;
      result.end = elm.selectionEnd as number;
      result.text = elm.value.substring(result.start, result.end);
    } else {
      const getSelection = window.getSelection;
      if (getSelection) {
        // all browsers, except IE before version 9
        const selRange = getSelection();
        result.start = 0; // todo
        result.text = (selRange as Selection).toString();
        result.end = result.text.length; // todo
      } else {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const createRange = (window.document as any).selection.createRange;
        if (createRange) {
          // Internet Explorer
          const range = createRange();
          result.text = range.text;

          if (range && range.parentElement() === elm) {
            const len = elm.value.length;
            const normalizedValue = elm.value.replace(/\r\n/g, '\n');

            // Create a working TextRange that lives only in the input
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const textInputRange = (elm as any).createTextRange();
            textInputRange.moveToBookmark(range.getBookmark());

            // Check if the start and end of the selection are at the very end
            // of the input, since moveStart/moveEnd doesn't return what we want
            // in those cases
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const endRange = (elm as any).createTextRange();
            endRange.collapse(false);

            if (textInputRange.compareEndPoints('StartToEnd', endRange) > -1) {
              result.start = result.end = len;
            } else {
              result.start = -textInputRange.moveStart('character', -len);
              result.start += normalizedValue.slice(0, result.start).split('\n').length - 1;

              if (textInputRange.compareEndPoints('EndToEnd', endRange) > -1) {
                result.end = len;
              } else {
                result.end = -textInputRange.moveEnd('character', -len);
                result.end += normalizedValue.slice(0, result.end).split('\n').length - 1;
              }
            }
          }
        }
      }
    }
    return result;
  }

  private static isInputControl(elem: HTMLElement) {
    let tag: string;
    return elem && ((tag = elem.tagName.toLowerCase()) === 'input' || tag === 'textarea');
  }
}
